import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const CheckIcon = ({ viewBox, stroke, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 16 16'}>
    <path
      d="M1 11.097L6.12273 15L15 1"
      stroke={stroke || '#00B67A'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </BaseIcon>
);

export default CheckIcon;
